import React, { useContext, createContext, useReducer, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from './CardItem';
import FreightIcon from '../../../../../../assets/svg/vehicle.svg';
import DriverIcon from '../../../../../../assets/svg/driver.svg';
import CustomerIcon from '../../../../../../assets/svg/customer.svg';
import OrdersIcon from '../../../../../../assets/svg/orders.svg';
import { initialState, reducer, actions } from './reducer';
import { store as mainStore } from '../../../../../../store';
import useRules from '../../../../../../hooks/useRules';

export const store = createContext(null);
const { Provider } = store;

const Statistics = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { drivers, customers, orders, freights, loading } = state;
  const { showMessage, showError } = useContext(mainStore);
  const [rules, hasRule] = useRules();

  const loadStatistics = async () => {
    try {
      const statistics = await actions.loadStatistics();
      dispatch({ type: 'LOAD_STATISTICS', payload: statistics });
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    loadStatistics();
  }, []);
  return (
    <Provider value={{ state, dispatch, actions }}>
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="flex-start"
        spacing={2}
      >
        {hasRule('dashboard_orders_statistics_button') && (
          <Card
            loading={loading}
            title="سفارشات"
            icon={OrdersIcon}
            statistics={orders}
            link={'/protected/admin/orders'}
          />
        )}

        {hasRule('dashboard_customers_statistics_button') && (
          <Card
            title="صاحب‌بار"
            loading={loading}
            icon={CustomerIcon}
            statistics={customers}
            link={'/protected/admin/users/customers'}
          />
        )}
        {hasRule('dashboard_drivers_statistics_button') && (
          <Card
            title="راننده"
            loading={loading}
            icon={DriverIcon}
            statistics={drivers}
            link="/protected/admin/users/drivers"
          />
        )}
        {hasRule('dashboard_freights_statistics_button') && (
          <Card
            title="باربری"
            loading={loading}
            icon={FreightIcon}
            statistics={freights}
            link="/protected/admin/users/freights"
          />
        )}
      </Grid>
    </Provider>
  );
};

export default React.memo(Statistics);
